import type { ProLayoutProps } from "@ant-design/pro-components";

const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} = {
  navTheme: "light",
  colorPrimary: "#1677ff",
  layout: "mix",
  contentWidth: "Fluid",
  fixedHeader: true,
  fixSiderbar: true,
  colorWeak: false,
  title: "Ourwork",
  pwa: false,
  logo: "/logo.svg",
  iconfontUrl: "",
  token: {},
};

export default Settings;
